import React from 'react'

import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'

import nfLogoBlack from '@assets/images/icons/noteflight-logo-black.svg'
import nfLogo from '@assets/images/icons/noteflight-logo.svg'
import LinkButton from '@components/shared/LinkButton'
import '@styles/main.css'

const Error404Page: React.FC = () => {
  const { t } = useTranslation()

  const error = useRouteError()
  console.log(error)

  return (
    <div className="inset-0 flex flex-col h-screen bg-gray-light dark:bg-black-bg items-center px-2 pt-10">
      <img
        src={nfLogo}
        role="image"
        alt="Noteflight"
        className="max-w-[300px] w-full h-auto mb-1 dark:block hidden"
      />
      <img
        src={nfLogoBlack}
        role="image"
        alt="Noteflight"
        className="max-w-[300px] w-full h-auto mb-1 block dark:hidden"
      />
      <h1 className="w-full text-center text-h3 mb-2">{t('error404.title')}</h1>
      <p className="text-md text-gray-text mb-8 text-center">{t('error404.subtitle')}</p>
      <LinkButton variant="primary" href="/" title={t('error404.action')} external>
        {t('error404.action')}
      </LinkButton>
    </div>
  )
}

export default Error404Page
